import type { FunctionComponent } from 'react'
import { useEffect } from 'react'
import styled, { css } from 'styled-components'
import Close from '../../assets/icons/close.svg'
import Menu from '../../assets/icons/menu.svg'
import HeaderNavLinks from './HeaderNavLinks'
import { Breakpoint } from '../../hooks/useBreakpoint'
import Hidden from '../Theme/Hidden'
import Button, { Variant } from '../Button/Button'
import Icon from '../Icon/Icon'

const ESC_KEY = 'Escape'

const StyledButton = styled(Button)<{ active: boolean }>`
  padding: 1rem 0 1rem 1rem;
  color: var(--dark);
  font-weight: 400;
  justify-content: right;

  @media screen and (min-width: 48rem) {
    padding: 1rem 0 1rem 1rem;

    svg {
      width: 1rem;
      height: 1rem;
      margin-right: 0;
      margin-left: 0.5rem;
    }
  }

  ${({ active }) =>
    active &&
    css`
      font-weight: 700;
    `}
`

interface HeaderNavProps {
  isExpanded: boolean
  toggleMenu: () => void
  isMobile?: boolean
}

const HeaderNav: FunctionComponent<HeaderNavProps> = ({ isExpanded, toggleMenu, isMobile }) => {
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (isExpanded && event?.key === ESC_KEY) {
        toggleMenu()
      }
    }

    document.addEventListener('keydown', handleKeyPress)

    return () => {
      document.removeEventListener('keydown', handleKeyPress)
    }
  }, [isExpanded])
  return (
    <>
      <StyledButton
        variant={Variant.Menu}
        active={isExpanded}
        onClick={toggleMenu}
        size={isMobile ? 44 : undefined}
        id="menu"
        data-testid={isMobile ? 'mobileHeaderNavButton' : 'headerNavButton'}
        aria-expanded={isExpanded}
      >
        <Hidden maxBreakpoint={Breakpoint.Md}>Menu</Hidden>
        <Icon size={isMobile ? 24 : 16} color="var(--dark)">
          {isExpanded ? <Close /> : <Menu />}
        </Icon>
      </StyledButton>
      {isExpanded && <HeaderNavLinks toggleMenu={toggleMenu} isMobile={isMobile} />}
    </>
  )
}

export default HeaderNav
